import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bluetooth-b': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M196.5 260l97.9 103.3-148.6 148.6-2.7-198.3-86.1 86.1-31.4-31.4 108.1-108.4-108.1-108.4 31.4-31.4 86.1 86.1v-206.3l146 156.7zM237.3 157l-50.3-50.3 0.3 100.3zM187.4 313l-0.3 100.3 50.3-50.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bluetooth-b.js
// module id = 732
// module chunks = 0